(function ($) {
  'use strict';

  var initSearchPlaceholder = function () {
    var self = $(this);
    var $searchInput = $('input.gsc-input', self);

    $searchInput.attr('placeholder', 'Search by keyword or author');
  };

  /**
  * This is boilerplate: add a behavior to window.DP.behaviors
  */
  window.DP.behaviors.searchPlaceholder = {
    attach: function (context) {
      once('searchPlaceholder', '.gsc-control-cse', context)
        .forEach((e) => {
          initSearchPlaceholder.apply(e);
        });
      // $(context).find('.gsc-control-cse').once('searchPlaceholder').each(function () {
      //   initSearchPlaceholder.apply(this);
      // });
    }
  };

})(jQuery);
